import image2017Avif from '../../../../../../client/assets_seller/about_us/timeline/2017.avif';
import image2017 from '../../../../../../client/assets_seller/about_us/timeline/2017.jpg';
import image2017Webp from '../../../../../../client/assets_seller/about_us/timeline/2017.webp';
import image2018Avif from '../../../../../../client/assets_seller/about_us/timeline/2018.avif';
import image2018 from '../../../../../../client/assets_seller/about_us/timeline/2018.jpg';
import image2018Webp from '../../../../../../client/assets_seller/about_us/timeline/2018.webp';
import image2019Avif from '../../../../../../client/assets_seller/about_us/timeline/2019.avif';
import image2019 from '../../../../../../client/assets_seller/about_us/timeline/2019.jpg';
import image2019Webp from '../../../../../../client/assets_seller/about_us/timeline/2019.webp';
import image2021Avif from '../../../../../../client/assets_seller/about_us/timeline/2021.avif';
import image2021 from '../../../../../../client/assets_seller/about_us/timeline/2021.jpg';
import image2021Webp from '../../../../../../client/assets_seller/about_us/timeline/2021.webp';
import image2023Avif from '../../../../../../client/assets_seller/about_us/timeline/2023.avif';
import image2023 from '../../../../../../client/assets_seller/about_us/timeline/2023.jpg';
import image2023Webp from '../../../../../../client/assets_seller/about_us/timeline/2023.webp';
import image2025Avif from '../../../../../../client/assets_seller/about_us/timeline/2025.avif';
import image2025 from '../../../../../../client/assets_seller/about_us/timeline/2025.jpg';
import image2025Webp from '../../../../../../client/assets_seller/about_us/timeline/2025.webp';
import image2026Avif from '../../../../../../client/assets_seller/about_us/timeline/2026.avif';
import image2026 from '../../../../../../client/assets_seller/about_us/timeline/2026.jpg';
import image2026Webp from '../../../../../../client/assets_seller/about_us/timeline/2026.webp';
import ribbonImage from '../../../../../../client/assets_seller/about_us/timeline/ribbon.png';

export type TimelineMilestone = {
  imgAvif: string;
  imgHeight: number;
  imgSrc: string;
  imgWebp: string;
  imgWidth: number;
  year: string;
};

export const TIMELINE_MILESTONES: readonly TimelineMilestone[] = [
  {
    imgAvif: image2017Avif, imgHeight: 1012, imgSrc: image2017, imgWebp: image2017Webp, imgWidth: 1434, year: '2017',
  },
  {
    imgAvif: image2018Avif, imgHeight: 1096, imgSrc: image2018, imgWebp: image2018Webp, imgWidth: 1434, year: '2018',
  },
  {
    imgAvif: image2019Avif, imgHeight: 1096, imgSrc: image2019, imgWebp: image2019Webp, imgWidth: 1434, year: '2019',
  },
  {
    imgAvif: image2021Avif, imgHeight: 1018, imgSrc: image2021, imgWebp: image2021Webp, imgWidth: 1434, year: '2021',
  },
  {
    imgAvif: image2023Avif, imgHeight: 1012, imgSrc: image2023, imgWebp: image2023Webp, imgWidth: 1434, year: '2023',
  },
  {
    imgAvif: image2025Avif, imgHeight: 928, imgSrc: image2025, imgWebp: image2025Webp, imgWidth: 1434, year: '2025',
  },
  {
    imgAvif: image2026Avif, imgHeight: 1012, imgSrc: image2026, imgWebp: image2026Webp, imgWidth: 1434, year: '2026',
  },
] as const;

export const TIMELINE_RIBBON = {
  height: 651,
  src: ribbonImage,
  width: 3413,
} as const;
